import SocketiIOService from "./socket";

const chatSocket = new SocketiIOService(process.env.VUE_APP_SOCKET_URL);
const pricesSocket = new SocketiIOService(
  process.env.VUE_APP_PRICE_SOCKET_URL,
  "/ws"
);

export { chatSocket, pricesSocket };
